import type { CSSProperties } from 'react';

const styles: Record<string, CSSProperties> = {
    page: {
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: '32px 20px',
        boxSizing: 'border-box',
        background: 'linear-gradient(145deg, #f4f7fb 0%, #e7eef7 100%)',
        color: '#172033',
        fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    card: {
        width: 'min(100%, 680px)',
        boxSizing: 'border-box',
        padding: 'clamp(28px, 6vw, 56px)',
        background: '#ffffff',
        border: '1px solid rgba(23, 32, 51, 0.08)',
        borderRadius: '24px',
        boxShadow: '0 22px 70px rgba(28, 48, 78, 0.14)',
    },
    mark: {
        width: '48px',
        height: '48px',
        display: 'grid',
        placeItems: 'center',
        marginBottom: '28px',
        borderRadius: '14px',
        background: '#dcecff',
        color: '#1f5fae',
        fontSize: '24px',
        fontWeight: 700,
    },
    eyebrow: {
        margin: '0 0 12px',
        color: '#1f5fae',
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    title: {
        margin: '0',
        fontSize: 'clamp(28px, 5vw, 42px)',
        lineHeight: 1.1,
        letterSpacing: '-0.03em',
    },
    paragraph: {
        margin: '22px 0 0',
        color: '#4b5870',
        fontSize: '17px',
        lineHeight: 1.65,
    },
    destination: {
        display: 'inline-block',
        marginTop: '24px',
        color: '#174f91',
        fontSize: '20px',
        fontWeight: 700,
        textDecoration: 'none',
        wordBreak: 'break-word',
    },
    note: {
        margin: '30px 0 0',
        padding: '18px 20px',
        borderLeft: '4px solid #2d73c5',
        borderRadius: '0 12px 12px 0',
        background: '#f2f7fd',
        color: '#35435a',
        fontSize: '16px',
        lineHeight: 1.6,
    },
};

export function MigrationNotice() {
    return (
        <main style={styles.page} aria-labelledby="migration-title">
            <section style={styles.card}>
                <div style={styles.mark} aria-hidden="true">↗</div>
                <p style={styles.eyebrow}>Migration en cours</p>
                <h1 id="migration-title" style={styles.title}>L’application est temporairement indisponible</h1>
                <p style={styles.paragraph}>
                    Une migration est en cours. À partir du lundi 14 septembre, l’application sera accessible à la nouvelle adresse :
                </p>
                <a style={styles.destination} href="https://doucheflux.hypha.be">
                    doucheflux.hypha.be
                </a>
                <p style={styles.note}>
                    Lors de votre première connexion sur le nouveau site, vous devrez réinitialiser votre mot de passe.
                    Les anciens mots de passe n’étaient pas récupérables en clair et ont dû être recréés pendant la migration.
                </p>
            </section>
        </main>
    );
}
